<template>
  <div class="" >
    <login-after-head-center></login-after-head-center>
    <div id="member" class="container home-container flex">
      <side-nav></side-nav>
      <div id="order-us" class="award-page">
        <div class="home-allTitle award-title-cg">
          <span>我的订单</span>
        </div>
        <div class="award-nav award-nav-cg fc">
					<span class="text hand" @click="changeType(-1)" :class="{'goods-active':type==-1}">
						全部订单
					</span>
          <span class="line"></span>
          <span class="text hand" @click="changeType(5)" :class="{'goods-active':type==5}">
						待确认
					</span>
          <span class="line"></span>
          <!--					<span class="text hand">-->
          <!--						代发货-->
          <!--					</span>-->
          <!--					<span class="line"></span>-->
          <span class="text hand" @click="changeType(1)" :class="{'goods-active':type==1}">
						待发货
					</span>
          <span class="line"></span>
          <span class="text hand" @click="changeType(2)" :class="{'goods-active':type==2}">
						待收货
					</span>
          <span class="line"></span>
          <span class="text hand" @click="changeType(4)" :class="{'goods-active':type==4}">
						已完成
					</span>
          <span class="line"></span>
          <span class="text hand" @click="changeType(-3)" :class="{'goods-active':type==-3}">
						已取消
					</span>
          <!--<span class="line"></span>-->
          <!--<span class="text hand">-->
					<!--	已取消-->
					<!--</span>-->
          <!--<span class="line"></span>-->
          <!--<span class="text hand">-->
					<!--	积分订单-->
					<!--</span>-->
          <!--<span class="line"></span>-->
          <!--<span class="text hand">-->
					<!--	未清列表-->
					<!--</span>-->


        </div>


        <div class="evaluate-list ">
          <div class="list-title list-titleColor">
          	<span class="width518" style="width: 370px;">订单详情</span>
          		<span class="width90" style="text-align: left;width: 150px;">价格信息</span>
          		<span class="width90" style="text-align: left;width: 150px;">订单信息</span>
          		<span class="width170" style="width: 140px;">金额</span>
          		<span class="width90">订单状态</span>
          		<span class="width120">操作</span>
          </div>

          <div class="none-order " v-if="orderList.length==0 && orderLoading==false">
            <div class="none-left">
              <span class="none-left-img"></span>
            </div>
            <div class="none-right">
              <span class="">没有订单哦~</span>
            </div>
          </div>
          <div class="list-table" v-else v-loading="orderLoading">
            <div class="list-table-row fc-bet" v-for="(order,orderListIndex) in orderList" :key="orderListIndex">

              <!--<div class="width126 fcc">-->
              <!--  {{order.orderId}}-->
              <!--</div>-->
              <div class="col-rows">
<!--                -->
<!--                </router-link>-->
                <div class="col-row flex" v-for="(cart, cartInfoIndex) in order.cartInfo" :key="cartInfoIndex">

                  <div class="width400" style="width: 360px; margin-right: 10px;" >
                    <div class="img-txt flex">
                      <div class="img" style="width: 80px;height: 80px;">
                        <router-link :to="{path:'/details',query:{unique:cart.productAttrUnique}}">
                          <img :src="cart.productInfo.attrInfo.image" v-if="cart.productInfo.attrInfo.image" alt="" style="width: 80px;height: 80px">
                          <img :src="cart.productInfo.image" v-else-if="cart.productInfo.image" alt=""  style="width: 80px;height: 80px">
                          <img src="../assets/noll.png" v-else style="width: 80px;height: 80px"/>
                        </router-link>
                      </div>
                      <div class="txt" style="width: 245px;">
                        <div>
                          <router-link :to="{path:'/details',query:{unique:cart.productAttrUnique}}">
                           <h3 class="ddd">
                              {{ cart.productInfo.storeName }}
                           </h3>
                           <p class="ddd3">
                              {{ cart.productInfo.attrInfo.skuName}}
                           </p>
                          </router-link>
                        </div>
                        <div class="num">
                          <!--{{ cart.productInfo.attrInfo ? cart.productInfo.attrInfo.price : cart.productInfo.price }}x{{ cart.cartNum }}-->
                        </div>
                      </div>
                    </div>
                  </div>

                 <div class="width200 fcc" style="width: 150px; font-size: 12px;">
                   <div class="flex1">


                    产品单价：￥{{cart.vipTruePrice}}<br>
                    产品数量：{{cart.cartNum}}<br>
                    产品折扣：￥{{(cart.discountPrice*cart.cartNum).toFixed(2)}}<br>
                    小计：{{cart.refundStatus==0?('￥'+(cart.truePrice*cart.cartNum).toFixed(2)):"已取消"}}<br>
                  </div>
                 </div>
                </div>
              </div>

             <div class="width90 fcc" style=" font-size: 12px;width: 150px;">
                订单编号：{{order.orderId}}<br><br>
                收货人：{{order.realName}}<br>
                <!--收货地址：{{order.userAddress}}-->
                快递公司：{{order.deliveryName?order.deliveryName:'暂未发货'}}<br>
                快递单号：{{order.deliveryId?order.deliveryId:'暂未发货'}}
              </div>
              <div class="width170 fcc" style="width: 140px;">
                <b class="red">{{ order.payPrice.toFixed(2) }}</b>
              </div>
              <div class="width90 fcc">
                <span>{{ getStatus(order) }}</span>
              </div>
              <div class="width120 flex1 fcc">
                <a class="btn-"  @click="orderDetail(order.id)" style="margin-right: 10px;">详情</a>
                <br>
                <a class="btn-"  @click="cancelOrder(order.orderId)" v-if="order.refundStatus === 0 && order.paid === 1 && (order._status._type == 1||order._status._type == 5)">取消订单</a>
                <a class="btn-"  @click="takeOrder(order.orderId)" v-if="order._status._type == 2">确认收货</a>
                <a href="" class="btn-" v-if="order._status._type==4&&order.evaluate!=1" @click.prevent="openOrderCommentDialog(order.id)">
                  评价
                </a>
              </div>
            </div>
          </div>
          <el-pagination
              :page-size.sync="page.size"
              :total="page.total"
              :current-page.sync="page.page"
              style="margin-top: 8px;"
              layout="total, prev, pager, next, sizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>

      </div>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>



    <!-- 评价弹出框 -->


    <el-dialog
        title="评价"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="closeOrderCommentDialog">


      <div class="evaluate-box" :class="{on:fileList.length>4}">
        <div class="fc">
          <span>商品质量</span>
          <el-rate
              v-model="orderComment.productScore"
              show-text>
          </el-rate>
        </div>
        <div class="fc">
          <span>服务态度</span>
          <el-rate
              v-model="orderComment.serviceScore"
              show-text>
          </el-rate>
        </div>

        <div class="textarea">
          <el-input type="textarea" v-model="orderComment.comment" placeholder="商品满足你的期待么？说说你的想法,分享给想买的他们吧"></el-input>

        </div>

        <el-upload
            class="upload-wrap"
            list-type="picture-card"
            multiple
            :limit="5"
            action="https://zxapi.tengen.com.cn/api/pc-shop/upload"
            :on-remove="handleRemove"
            :on-success="handleUploadSuccess"
            :before-remove="beforeRemove"
            :file-list="fileList"
            multiple

        >

          <i class="el-icon-plus"></i>

        </el-upload>

        <p>
          最多上传5张图片
          ({{fileList.length}}/5)
        </p>

      </div>

      <span slot="footer" class="dialog-footer">
		    <el-button @click="closeOrderCommentDialog">取 消</el-button>
		    <el-button type="primary" @click="submitOrderComment">确 定</el-button>
		  </span>
    </el-dialog>

    <el-dialog :visible.sync="showBigPic">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import {getOrderList, orderComment, takeOrder, cancelOrder, verifyOrder} from '@/api/order'
//import { cancelOrderHandle, payOrderHandle, takeOrderHandle } from '@/libs/order'
import { mapGetters } from 'vuex'
//import { isWeixin, dataFormat } from '@/utils'

const STATUS = ['待付款', '待发货', '待收货', '待评价', '已完成', '待确认', '', '', '', '待付款']

const NAME = 'MyOrder'

export default {
  name: NAME,
  data() {
    return {
      orderLoading:true,
      fileList:[],
      value:5,
      value2:5,
      dialogVisible:false,
      dialogImageUrl:"",
      showBigPic:false,
      offlinePayStatus: 2,
      orderData: {},
      type: -1,
      loading:false,
      orderList: [{}],
      pay: false,
      payType: ['yue', 'weixin'],
      from: "PC",
      orderComment:{
        oid: 0,
        comment: '',
        pics: '',
        productScore: 5,
        serviceScore: 5
      },
      page:{
        page:1,
        size:10,
        total:0
      }
    }
  },
  components: {},
  computed: mapGetters(['userInfo']),
  mounted: function() {
    console.log(this)
    this.type = parseInt(this.$route.query.type) || -1
    this.changeType(this.type)
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.orderList = []
      this.getOrderList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.orderList = []
      this.getOrderList()
    },

    takeOrder(orderId) {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        takeOrder({uni: orderId}).finally(() => {
          this.$message({
            type: 'success',
            message: '收货成功!'
          });
          this.changeType(this.type)

        })
      });
    },
    orderDetail(orderId){
      this.$router.push({path: '/orderDetail', query: {orderId: orderId}})
    },
    cancelOrder(orderId) {

      this.$prompt('请输入申请理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        verifyOrder({uni:orderId,text:value}).finally(() => {
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
          this.changeType(this.type)
        });
      })
    },
    openOrderCommentDialog(oid){
      this.fileList=[]
      this.orderComment={
        oid: oid,
        comment: '',
        pics: '',
        productScore: 5,
        serviceScore: 5
      }
      this.dialogVisible = true
    },
    closeOrderCommentDialog(){
      this.fileList=[]
      this.orderComment={
        oid: 0,
        comment: '',
        pics: '',
        productScore: 5,
        serviceScore: 5
      }
      this.dialogVisible=false
    },
    // 图片上传
    handleUploadSuccess(response, file, fileList) {
      console.log("handleUploadSuccess.response",response)
      console.log("handleUploadSuccess.file",file);
      console.log("handleUploadSuccess.fileList",fileList);
      var imgStr = fileList.map(function(obj,index){
        return obj.response.link;
      }).join(",");
      this.orderComment.pics = imgStr;
    },
    handleRemove(file, fileList) {
      console.log("handleRemove.file",file);
      console.log("handleRemove.fileList",fileList);
      var imgStr = fileList.map(function(obj,index){
        return obj.response.link;
      }).join(",");
      this.orderComment.pics = imgStr;
    },
    beforeRemove(file, fileList) {
      console.log("beforeRemove.file",file);
      console.log("beforeRemove.fileList",fileList);
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    submitOrderComment(){
      console.log("submitOrderComment",this.orderComment);
      orderComment(this.orderComment).then(res=>{
        this.$message({
          type: 'success',
          message: '评价成功!'
        });
        this.closeOrderCommentDialog()
        this.changeType(this.type)
      })
    },
    //dataFormat,
    setOfflinePayStatus: function(status) {
      var that = this
      that.offlinePayStatus = status
      if (status === 1) {
        if (that.payType.indexOf('offline') < 0) {
          that.payType.push('offline')
        }
      }
    },
    // takeOrder(order) {
    //   takeOrderHandle(order.orderId).finally(() => {
    //     this.reload()
    //   })
    // },
    reload() {
      this.changeType(this.type)
    },
    changeType(type) {
      this.type = type
      this.orderList = []
      this.page.page = 1
      this.getOrderList()
    },
    getOrderList() {
      if(this.loading)return
      this.loading=true
      this.orderLoading=true
      const { type } = this
      getOrderList({
        page:this.page.page,
        limit:this.page.size,
        orderType:0,
        type,
      }).then(res => {
        this.page.total= res.total
        this.orderList = this.orderList.concat(res.data)
      }).finally(()=>{
        this.loading=false
        this.orderLoading=false
      })
    },
    getStatus(order) {
      if(order._status._type==-1){
        return "申请退款中"
      }else if(order._status._type==-2){
        return "已退款"
      }
      return STATUS[order._status._type]
    },
    // cancelOrder(order) {
    //   cancelOrderHandle(order.orderId)
    //       .then(() => {
    //         this.orderList.splice(this.orderList.indexOf(order), 1)
    //       })
    //       .catch(() => {
    //         this.reload()
    //       })
    // },
    toPay() {},
  }
}
</script>

<style scoped lang="less">
	.ddd{

		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		word-break: break-all;
	}
	.ddd3{

		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		word-break: break-all;
	}
</style>


